/**
 * Text Input Showcase Page
 *
 * This page demonstrates all text input types available in the RUL form system:
 * - text
 * - email
 * - password
 * - number
 * - textarea
 * - url
 * - tel
 *
 * Route: /apps/examples/forms/text-input-showcase
 */

import { message } from 'antd';
import { UniversalRULForm } from '@/components/features/rul/UniversalRULForm';
import './TextInputShowcasePage.css';

export const TextInputShowcasePage: React.FC = () => {
  const handleSuccess = (data: any) => {
    message.success('Form validated successfully!');
    console.log('Form submitted:', data);
  };

  const handleError = (errors: Record<string, string>) => {
    message.error('Please fix validation errors');
    console.error('Validation errors:', errors);
  };

  return (
    <div className="text-input-showcase-page">
      <div className="text-input-showcase-container">
        <UniversalRULForm
          formUrl="/formsexamples/rul/forms/text_input_showcase"
          onSuccess={handleSuccess}
          onError={handleError}
          className="text-input-showcase-form"
          debounceMs={500}
        />
      </div>
    </div>
  );
};
